import React from 'react';

import {
    ProducerSearchResultsMap,
    ProducerSearchFilters,
    ProducerSearchResultsList,
} from '/components/producer-search/components';

const ProducerSearchDesktop = ({ activeHit }) => {
    return (
        <div className="producer-search-desktop">
            <div className="producer-search-desktop__results-map">
                <ProducerSearchResultsMap activeHit={activeHit} />
            </div>
            <div className="producer-search-desktop__content">
                <div className="producer-search-desktop__filters">
                    <ProducerSearchFilters />
                </div>
                <div className="producer-search-desktop__results-list">
                    <ProducerSearchResultsList />
                </div>
            </div>
        </div>
    );
};

export { ProducerSearchDesktop };
